function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.6577 17.6884V9.11801C43.6577 7.50432 43.0202 5.95595 41.884 4.81008C40.7478 3.6642 39.2049 3.01362 37.5913 3H29.008",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  className: "color-error-stroke"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6884 3H9.11801C7.49541 3 5.93927 3.64457 4.79192 4.79192C3.64457 5.93927 3 7.49541 3 9.11801V17.6884",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  className: "color-error-stroke"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M29.008 43.6577H37.5913C39.196 43.6442 40.7312 43.0007 41.8659 41.866C43.0007 40.7312 43.6442 39.196 43.6577 37.5913V29.008",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  className: "color-error-stroke"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3 29.008V37.5913C3.01362 39.2049 3.6642 40.7478 4.81008 41.884C5.95595 43.0202 7.50432 43.6577 9.11801 43.6577H17.6884",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  className: "color-error-stroke"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3835 39.6435C15.3204 39.6435 17.7013 37.2627 17.7013 34.3258C17.7013 31.3888 15.3204 29.008 12.3835 29.008C9.44661 29.008 7.06577 31.3888 7.06577 34.3258C7.06577 37.2627 9.44661 39.6435 12.3835 39.6435Z",
  stroke: "#FF7A00",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "color-error-stroke"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3835 36.6749C12.1952 36.6749 12.0147 36.7497 11.8816 36.8828C11.7484 37.0159 11.6736 37.1965 11.6736 37.3848C11.66 37.4851 11.668 37.5873 11.6971 37.6843C11.7262 37.7813 11.7758 37.871 11.8424 37.9473C11.909 38.0235 11.9912 38.0847 12.0834 38.1266C12.1757 38.1685 12.2758 38.1902 12.3771 38.1902C12.4784 38.1902 12.5785 38.1685 12.6707 38.1266C12.7629 38.0847 12.8451 38.0235 12.9117 37.9473C12.9784 37.871 13.0279 37.7813 13.057 37.6843C13.0861 37.5873 13.0941 37.4851 13.0805 37.3848C13.0805 37.1987 13.0075 37.0201 12.8772 36.8873C12.7468 36.7545 12.5696 36.6782 12.3835 36.6749Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6994 31.228V34.9453C11.6994 35.1233 11.7701 35.294 11.896 35.4199C12.0219 35.5457 12.1926 35.6164 12.3706 35.6164C12.5486 35.6164 12.7193 35.5457 12.8452 35.4199C12.9711 35.294 13.0418 35.1233 13.0418 34.9453V31.228C13.0418 31.05 12.9711 30.8793 12.8452 30.7534C12.7193 30.6275 12.5486 30.5568 12.3706 30.5568C12.1926 30.5568 12.0219 30.6275 11.896 30.7534C11.7701 30.8793 11.6994 31.05 11.6994 31.228Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M39.2106 27.7832L38.0765 25.5149C28.2183 26.1256 18.2728 26.1256 8.41462 25.5149L7.28049 27.7832",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "color-error-stroke"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M38.3546 25.3546L34.6488 17.3546C34.1194 16.1165 32.8841 15.3546 31.6488 15.3546H15.0605C13.8252 15.3546 12.5899 16.1165 12.0605 17.3546L8.35464 25.3546",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "color-error-stroke"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M37.9892 24.1273L38.5127 24.2936L38.7744 23.2467C38.8616 22.8105 39.2978 22.5487 39.734 22.636L42.7002 23.3339C42.8747 23.4211 43.0492 23.5084 43.0492 23.7701V24.468C43.0492 25.0787 42.613 25.5149 42.0023 25.5149H37.9892",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "color-error-stroke"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M8.35464 24.3546L7.89116 24.2936L7.62944 23.2467C7.5422 22.8105 7.106 22.5487 6.66979 22.636L3.70361 23.4211C3.52913 23.4211 3.35464 23.5956 3.35464 23.7701V24.468C3.35464 25.0787 3.79085 25.5149 4.40153 25.5149H8.41461",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "color-error-stroke"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M23.1922 17.0122H25.1988C25.4605 17.0122 25.7222 17.1867 25.8095 17.5356L26.0712 18.3208C26.1584 18.757 25.8967 19.1932 25.4605 19.1932H21.0112C20.575 19.1932 20.226 18.757 20.4005 18.3208L20.575 17.5356C20.6623 17.2739 20.924 17.0122 21.1857 17.0122H23.1922ZM23.1922 17.0122V15.3546",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "color-error-stroke"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6948 25.6021C27.6948 23.9446 29.0034 22.5487 30.661 22.5487C32.3186 22.5487 33.7144 23.8573 33.7144 25.5149",
  stroke: "#FF7A00",
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "color-error-stroke"
});
function SvgWindshieldTooCloseToImgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindshieldTooCloseToImgEdge);
export default __webpack_public_path__ + "static/media/windshield-too-close-to-img-edge.377d5287f95640dcfd33dab479195e77.svg";
export { ForwardRef as ReactComponent };